import React from 'react'

function Googlemap() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                      
<iframe className="iframe-fluid mb-2" height="300" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Lodge%20Green%20House,%2018/19,%20MM%20Ghosh%20Rd,%20SADAR%20HOSPITAL%20MORE,%20Krishnanagar,%20West%20Bengal%20741101%20+(Lodge%20Green%20House,%2018/19,%20MM%20Ghosh%20Rd,%20SADAR%20HOSPITAL%20MORE,%20Krishnanagar,%20West%20Bengal%20741101)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe> 
<iframe src="https://www.google.com/maps/embed?pb=!4v1771501428609!6m8!1m7!1slM6WV47TOwJjO5NIcbToTA!2m2!1d23.40668246945635!2d88.49172559009367!3f304.8555270928015!4f14.651223623450122!5f0.7820865974627469" width="100%" height="330"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Googlemap